module.exports = __webpack_public_path__ + "static/media/01A.b5c2328b.png";